
define(function (require) {
    "use strict";

    var Backbone = require('backbone');

    var INPUT_TYPE = {
        Text : 'text'
    };
    var InputSearchModel = Backbone.Model.extend({
        defaults : {
            type : INPUT_TYPE.Text,
            minLength : 0,
            maxLength : 2000,
            placeholder : '',
            name : 'value',
            tabindex : '',
            autofocus : false

        }
    });

    InputSearchModel.Type = INPUT_TYPE;

    return InputSearchModel;
});
